'use client';

import { c as _c } from "react/compiler-runtime";
import { useAnalytics } from '@repo/analytics/analytics-provider';
import { Logo } from '@repo/design-system/components/ds/logo';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { Type } from '@repo/design-system/components/ui/type';
import { useHostMode, useHostType } from '@repo/host/hooks/use-host-info';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectIsMobileViewport } from '@repo/store/maps/slices/clientContext';
import { selectExternalMapId } from '@repo/store/maps/slices/mapData';
import { HostMode, HostType } from '@repo/types/host';
import { useCallback, useEffect, useState } from 'react';
export const Watermark = () => {
  const $ = _c(25);
  const hostMode = useHostMode();
  const hostType = useHostType();
  const analytics = useAnalytics();
  const externalMapId = useAppSelector(selectExternalMapId);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["game_map"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useT(t0);
  const isMobileViewport = useAppSelector(selectIsMobileViewport);
  const [isEmbed, setIsEmbed] = useState(false);
  let t1;
  let t2;
  if ($[1] !== hostMode || $[2] !== hostType) {
    t1 = () => {
      setIsEmbed(hostMode === HostMode.EMBED && hostType === HostType.WEB);
    };
    t2 = [hostMode, hostType];
    $[1] = hostMode;
    $[2] = hostType;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== analytics || $[6] !== externalMapId || $[7] !== hostType) {
    t3 = () => {
      analytics.event("game_map_embed_watermark_click", {
        mapId: externalMapId,
        platform: hostType
      });
      const url = new URL(window.location.href);
      url.searchParams.delete("isMiniMapMode");
      window.open(url.toString(), "_blank");
    };
    $[5] = analytics;
    $[6] = externalMapId;
    $[7] = hostType;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleClick = t3;
  const noBackground = isMobileViewport && !isEmbed;
  let t4;
  if ($[9] !== isEmbed || $[10] !== noBackground) {
    t4 = css.raw({
      position: "absolute",
      right: noBackground ? undefined : isEmbed ? undefined : "0",
      left: noBackground ? "16" : isEmbed ? "0" : undefined,
      bottom: noBackground ? "120" : isEmbed ? "0" : undefined,
      zIndex: 2,
      padding: noBackground ? "0" : "8",
      pointerEvents: isEmbed ? "auto" : "none",
      userSelect: "none",
      cursor: isEmbed ? "pointer" : undefined,
      borderTopRightRadius: noBackground ? "none" : isEmbed ? "12" : "none",
      borderBottomLeftRadius: noBackground ? "none" : isEmbed ? "none" : "12",
      overflow: "hidden",
      background: noBackground ? "[none]" : "[rgba(0, 0, 0, 0.3)]",
      backdropFilter: noBackground ? "[none]" : "[blur(24px)]"
    });
    $[9] = isEmbed;
    $[10] = noBackground;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const watermarkStyles = t4;
  const t5 = isEmbed ? "start" : "end";
  const t6 = isEmbed ? "start" : "end";
  const t7 = isEmbed ? "4" : undefined;
  const t8 = isEmbed ? handleClick : undefined;
  let t9;
  if ($[12] !== isEmbed || $[13] !== t) {
    t9 = isEmbed && <Type variant="caption" color="gray.200">{t(_temp)}</Type>;
    $[12] = isEmbed;
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = isEmbed ? "[78px]" : "[60px]";
  let t11;
  if ($[15] !== t10) {
    t11 = <Logo variant="wordmark" width={t10} color="white" aria-label="Wand" />;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9 || $[23] !== watermarkStyles) {
    t12 = <FlexColumn align={t5} justify={t6} gap={t7} className={watermarkStyles} onClick={t8}>{t9}{t11}</FlexColumn>;
    $[17] = t11;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = watermarkStyles;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
};
function _temp($) {
  return $.powered_by;
}